import React from 'react';
import './TimerSection.css';

interface TimerSectionProps {
  questionNumber?: number;
  totalQuestions?: number;
  timeSeconds: number;
  progress: number;
  primaryColor?: string; // Optional custom primary color for timer
  lowTimeThreshold?: number; // Optional threshold for low time (default: 5)
}

export const TimerSection: React.FC<TimerSectionProps> = ({
  questionNumber,
  totalQuestions,
  timeSeconds,
  progress,
  primaryColor,
  lowTimeThreshold = 5,
}) => {
  const isLowTime = timeSeconds <= lowTimeThreshold;
  const hasNumbers = typeof questionNumber === 'number' && typeof totalQuestions === 'number';
  const questionLabel = hasNumbers
    ? `Question ${questionNumber} of ${totalQuestions}`
    : 'Question — of —';

  return (
    <div className="timer-section">
      <div className="timer-section__header">
        <span className="timer-section__question-number">
          {questionLabel}
        </span>
        <div className={`timer-section__time ${isLowTime ? 'timer-section__time--low' : ''}`}>
          {timeSeconds}s
        </div>
      </div>
      
      {/* Timer slider */}
      <div className="timer-section__slider">
        <div 
          className={`timer-section__slider-fill ${isLowTime ? 'timer-section__slider-fill--low' : ''}`}
          style={{ 
            width: `${progress}%`,
            ...(primaryColor && !isLowTime ? { background: primaryColor } : {})
          }}
        />
      </div>
    </div>
  );
};
